const state = {
    showVerticalMenu: false,

    counters: {},
    showCounters: false,

    menuRoutes: {},
    client: null,
}

const mutations = {
    SET_CLIENT(state, client) {
        state.client = client
    },

    RESET_CLIENT(state) {
        state.client = null
    },

    SET_COUNTERS(state, counters) {
        state.counters = counters
    },

    SHOW_COUNTERS(state) {
        state.showCounters = true
    },

    HIDE_COUNTERS(state) {
        state.showCounters = false
    },

    SET_MENU_ROUTES(state, menuRoutes) {
        state.menuRoutes = menuRoutes
    },

    SHOW_VERTICAL_MENU(state) {
        state.showVerticalMenu = true
    },
    HIDE_VERTICAL_MENU(state) {
        state.showVerticalMenu = false
    },
}

const actions = {
    async getCounters({ commit }, client) {
        try {
            const response = await axios.get(
                `clients/${client}/pendingPoints/counters`
            )
            commit('SET_COUNTERS', response.data.data)
        } catch (error) {
            console.log('counters not loaded')
        }
    },

    async getRoutes({ commit }, client) {
        try {
            const response = await axios.get(`clients/${client}/routes`)
            commit('SET_MENU_ROUTES', response.data)
        } catch (error) {
            // console.log(error)
            console.log('menuRoutes not loaded')
        }
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
